import React, { useState, useRef } from "react";
import "./Contact.css";
import { Flex, Header, SafeArea, Container } from "../../components/layout";
import { Image, Text, Input, Button, Form } from "../../components/ui";
import Alert from "../../components/ui/alert/Alert.jsx";
import { IoCall, IoMail } from "react-icons/io5";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../components/firebase/firebase";
import { logEvent, serializeError } from "../../utils/logger";
// import { TbChevronRight } from "react-icons/tb";

const CONTACT_EMAIL = "contact@lecrin-sauvage.fr";

const MESSAGE_MIN = 30;
const MESSAGE_MAX = 2000;
const MIN_FILL_MS = 3000; // un humain met plus de 3 s à remplir le formulaire
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const WORDS = ["zéro", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf"];
const newCaptcha = () => {
  const a = 1 + Math.floor(Math.random() * 9);
  const b = 1 + Math.floor(Math.random() * 9);
  const plus = Math.random() < 0.5 || a <= b;
  return {
    question: `Combien font ${WORDS[a]} ${plus ? "plus" : "moins"} ${WORDS[b]} ?`,
    answer: plus ? a + b : a - b,
  };
};

const validate = ({ firstName, lastName, email, phone, message }) => {
  const errors = {};
  if (firstName.trim().length < 2) errors.firstName = "Prénom requis.";
  if (lastName.trim().length < 2) errors.lastName = "Nom requis.";
  if (!EMAIL_RE.test(email.trim())) errors.email = "Email invalide.";
  if (phone.trim() && phone.replace(/\D/g, "").length < 8)
    errors.phone = "Numéro de téléphone invalide.";
  const len = message.trim().length;
  if (len < MESSAGE_MIN)
    errors.message = `Message trop court (${len}/${MESSAGE_MIN} caractères minimum).`;
  else if (len > MESSAGE_MAX)
    errors.message = `Message trop long (${MESSAGE_MAX} caractères maximum).`;
  return errors;
};

const FONT = "font-family:'Comic Sans MS','Comic Neue',cursive,sans-serif;";

const escapeHtml = (str = "") =>
  str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const emailWrapper = (content) => `
<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml" style="color-scheme:light;supported-color-schemes:light;">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta name="color-scheme" content="light only" />
  <meta name="supported-color-schemes" content="light only" />
  <style>
    :root { color-scheme: light only; supported-color-schemes: light only; }
    @media (prefers-color-scheme: dark) {
      body, table, td { background-color: #f8efd9 !important; }
    }
    [data-ogsc] body, [data-ogsc] table, [data-ogsc] td { background-color: #f8efd9 !important; }
    [data-ogsc] span, [data-ogsc] p, [data-ogsc] a { color: inherit !important; }
  </style>
</head>
<body style="${FONT}margin:0;padding:0;background-color:#f8efd9;" bgcolor="#f8efd9">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" bgcolor="#f8efd9" style="${FONT}background:#f8efd9;">
    <tr><td align="center">
      <table role="presentation" width="600" cellpadding="0" cellspacing="0" bgcolor="#f8efd9" style="${FONT}width:600px;max-width:100%;background:#f8efd9;">
        <tr><td align="center" style="${FONT}padding:44px 40px 0;">
          <span style="${FONT}font-size:17px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#023c40;">L'Écrin Sauvage</span>
        </td></tr>
        <tr><td align="center" style="${FONT}padding:14px 0 0;">
          <table role="presentation" cellpadding="0" cellspacing="0"><tr>
            <td width="36" height="3" style="${FONT}background:#006c3f;font-size:0;line-height:0;">&nbsp;</td>
          </tr></table>
        </td></tr>
        ${content}
      </table>
    </td></tr>
  </table>
</body>
</html>
`;

const buildAdminEmailHtml = ({
  firstName,
  lastName,
  email,
  phone,
  message,
}) => {
  const safe = {
    firstName: escapeHtml(firstName),
    lastName: escapeHtml(lastName),
    email: escapeHtml(email),
    phone: escapeHtml(phone),
    message: escapeHtml(message).replace(/\n/g, "<br />"),
  };
  return emailWrapper(`
    <tr><td align="center" style="${FONT}padding:28px 40px 6px;">
      <span style="${FONT}font-size:30px;font-weight:700;color:#023c40;">Nouveau message de contact</span>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:0 40px 36px;">
      <span style="${FONT}font-size:15px;line-height:1.6;color:#606060;">Un visiteur du site vient de remplir le formulaire de contact.</span>
    </td></tr>
    <tr><td style="${FONT}padding:0 40px;">
      <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
        <tr>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#939394;width:110px;">Prénom</td>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:16px;color:#000;font-weight:600;">${safe.firstName}</td>
        </tr>
        <tr>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#939394;">Nom</td>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:16px;color:#000;font-weight:600;">${safe.lastName}</td>
        </tr>
        <tr>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#939394;">Email</td>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:16px;">
            <a href="mailto:${safe.email}" style="${FONT}color:#006c3f;font-weight:600;text-decoration:none;">${safe.email}</a>
          </td>
        </tr>
        <tr>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#939394;">Téléphone</td>
          <td style="${FONT}padding:14px 0;border-bottom:1px solid #dcd5c2;font-size:16px;color:#000;">
            <a href="tel:${safe.phone}" style="${FONT}color:#000;font-weight:600;text-decoration:none;">${safe.phone}</a>
          </td>
        </tr>
      </table>
    </td></tr>
    <tr><td style="${FONT}padding:32px 40px 0;">
      <span style="${FONT}font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#939394;">Message</span>
    </td></tr>
    <tr><td style="${FONT}padding:10px 40px 40px;">
      <span style="${FONT}font-size:16px;line-height:1.7;color:#000;">${safe.message}</span>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:8px 40px 44px;">
      <a href="mailto:${safe.email}" style="${FONT}display:inline-block;padding:12px 28px;background:#006c3f;color:#f7f7f7;font-size:15px;font-weight:600;text-decoration:none;border-radius:30px;">Répondre à ${safe.firstName}</a>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:20px 40px 36px;border-top:1px solid #dcd5c2;">
      <span style="${FONT}font-size:12px;color:#939394;">Reçu via le formulaire de contact — lecrin-sauvage.fr</span>
    </td></tr>
  `);
};

const buildUserEmailHtml = ({ firstName, message }) => {
  const safe = {
    firstName: escapeHtml(firstName),
    message: escapeHtml(message).replace(/\n/g, "<br />"),
  };
  return emailWrapper(`
    <tr><td align="center" style="${FONT}padding:28px 40px 10px;">
      <span style="${FONT}font-size:32px;font-weight:700;color:#023c40;">Votre message est bien arrivé</span>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:0 40px 4px;">
      <span style="${FONT}font-size:16px;line-height:1.7;color:#000;">Bonjour ${safe.firstName},</span>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:10px 40px 0;">
      <span style="${FONT}font-size:16px;line-height:1.7;color:#000;">
        Merci pour votre message, nous l'avons bien reçu. Nous vous répondrons personnellement dans les meilleurs délais.
      </span>
    </td></tr>
    <tr><td style="${FONT}padding:32px 40px 0;">
      <span style="${FONT}font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#939394;">Rappel de votre message</span>
    </td></tr>
    <tr><td style="${FONT}padding:10px 40px 0;border-left:2px solid #006c3f;">
      <span style="${FONT}display:inline-block;padding-left:16px;font-size:15px;line-height:1.7;color:#606060;font-style:italic;">
        ${safe.message}
      </span>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:40px 40px 8px;">
      <a href="https://lecrin-sauvage.fr/calendrier" style="${FONT}display:inline-block;padding:12px 28px;background:#006c3f;color:#f7f7f7;font-size:15px;font-weight:600;text-decoration:none;border-radius:30px;">Voir les prochains stages</a>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:32px 40px 8px;">
      <span style="${FONT}font-size:16px;line-height:1.7;color:#000;">À très bientôt,<br>L'équipe du Lécrin Sauvage</span>
    </td></tr>
    <tr><td align="center" style="${FONT}padding:20px 40px 36px;border-top:1px solid #dcd5c2;">
      <span style="${FONT}font-size:12px;color:#939394;line-height:1.6;">
        L'Écrin Sauvage — 286 route de Narreyroux, 05290 Puy-Saint-Vincent<br>
        06 73 98 96 46 · contact@lecrin-sauvage.fr
      </span>
    </td></tr>
  `);
};

function Contact() {
  // const [active, setActive] = React.useState(0);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null
  const [errors, setErrors] = useState({});
  const [captcha, setCaptcha] = useState(newCaptcha);
  const [captchaInput, setCaptchaInput] = useState("");
  const [honeypot, setHoneypot] = useState("");
  const openedAt = useRef(Date.now());

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setStatus(null);

    // Anti-bot : champ piège rempli ou formulaire envoyé trop vite
    // -> on fait semblant de réussir sans rien envoyer.
    if (honeypot || Date.now() - openedAt.current < MIN_FILL_MS) {
      setStatus("success");
      return;
    }

    const found = validate(form);
    if (captchaInput.trim() !== String(captcha.answer))
      found.captcha = "Réponse incorrecte à la question anti-spam.";
    setErrors(found);
    if (Object.keys(found).length > 0) {
      if (found.captcha) {
        setCaptcha(newCaptcha());
        setCaptchaInput("");
      }
      return;
    }

    setLoading(true);
    const firstName = form.firstName.trim();
    const lastName = form.lastName.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();
    const message = form.message.trim();

    try {
      // Notification à l'administrateur du site
      await addDoc(collection(db, "mails"), {
        to: [CONTACT_EMAIL],
        message: {
          subject: `Nouveau message de contact de ${firstName} ${lastName}`,
          html: buildAdminEmailHtml({
            firstName,
            lastName,
            email,
            phone,
            message,
          }),
        },
      });

      // Accusé de réception envoyé à l'utilisateur
      await addDoc(collection(db, "mails"), {
        to: [email],
        message: {
          subject: "Nous avons bien reçu votre message",
          html: buildUserEmailHtml({ firstName, message }),
        },
      });

      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
      setErrors({});
      setCaptcha(newCaptcha());
      setCaptchaInput("");
      openedAt.current = Date.now();
      setStatus("success");
    } catch (error) {
      console.error("Erreur lors de l'envoi du message :", error);
      logEvent("ERROR", "DB", "Failed to send contact message", {
        error: serializeError(error),
        collection: "mails",
      });
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  // const data = [
  //   {
  //     title: "Lorem ipsum dolor sit",
  //     content:
  //       "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Error, quae nobis repudiandae nam impedit quibusdam qui aperiam illum ipsam dicta nostrum quasi velit officiis? Voluptates dolorem consectetur corporis architecto culpa!",
  //   },
  //   {
  //     title: "Lorem ipsum dolor sit",
  //     content:
  //       "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Error, quae nobis repudiandae nam impedit quibusdam qui aperiam illum ipsam dicta nostrum quasi velit officiis? Voluptates dolorem consectetur corporis architecto culpa!",
  //   },
  //   {
  //     title: "Lorem ipsum dolor sit",
  //     content:
  //       "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Error, quae nobis repudiandae nam impedit quibusdam qui aperiam illum ipsam dicta nostrum quasi velit officiis? Voluptates dolorem consectetur corporis architecto culpa!",
  //   },
  // ];

  return (
    <SafeArea className="Contact">
      <Flex type="col-center" gap={150}>
        <Flex type="col-center" gap={20}>
          <Header title="Infos pratiques et Contact" />
          <Flex type="center" gap={30} className="ctn-links" wrap>
            <a href="tel:+33673989646">
              <Flex type="center" gap={10}>
                <Flex type="center" className="ctn-icon">
                  <IoCall className="icon" />
                </Flex>
                <Text>06 73 98 96 46</Text>
              </Flex>
            </a>
            <a href="mailto:contact@lecrin-sauvage.fr">
              <Flex type="center" gap={10}>
                <Flex type="center" className="ctn-icon">
                  <IoMail className="icon" />
                </Flex>
                <Text>contact@lecrin-sauvage.fr</Text>
              </Flex>
            </a>
            <a href="https://www.google.com/maps/search/?api=1&query=286+route+de+Narreyroux,+05290+Puy+Saint+Vincent">
              <Flex type="center" gap={10}>
                <Flex type="center" className="ctn-icon">
                  <Image
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Google_Maps_icon_%282020%29.svg/1200px-Google_Maps_icon_%282020%29.svg.png"
                    objectFit={"contain"}
                    className="icon"
                  />
                </Flex>
                <Text>
                  286 route de Narreyroux, <br />
                  Puy-Saint-Vincent
                </Text>
              </Flex>
            </a>
          </Flex>
        </Flex>

        <Flex type="col-center" gap={20} className="ctn-form">
          <Header title="Nous contacter" />
          <Form className="contact-form" onSubmit={handleSubmit} noValidate>
            <div className="hp-field" aria-hidden="true">
              <label htmlFor="website">Ne pas remplir</label>
              <input
                id="website"
                type="text"
                name="website"
                tabIndex={-1}
                autoComplete="off"
                value={honeypot}
                onChange={(e) => setHoneypot(e.target.value)}
              />
            </div>
            <Container className="row">
              <Input
                label="Prénom *"
                name="firstName"
                value={form.firstName}
                onChange={handleChange("firstName")}
              />
              <Input
                label="Nom *"
                name="lastName"
                value={form.lastName}
                onChange={handleChange("lastName")}
              />
            </Container>
            <Container className="row">
              <Input
                label="Email *"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange("email")}
              />
              <Input
                label="Téléphone"
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange("phone")}
              />
            </Container>
            <Input
              label={`Message * (${form.message.trim().length}/${MESSAGE_MIN} min)`}
              maxLength={MESSAGE_MAX}
              type="textarea"
              name="message"
              value={form.message}
              onChange={handleChange("message")}
            />

            <Input
              label={`Anti-spam * : ${captcha.question}`}
              name="captcha"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
            />
            {Object.values(errors).map((err) => (
              <Alert key={err} type="error" text={err} />
            ))}
            {status === "success" && (
              <Alert
                type="info"
                text="Votre message a bien été envoyé. Merci !"
              />
            )}
            {status === "error" && (
              <Alert
                type="error"
                text="Une erreur est survenue, merci de réessayer."
              />
            )}

            <Button
              text="Envoyer"
              loading={loading}
              disabled={loading}
              type="submit"
            />
          </Form>
        </Flex>

        {/* <Flex type="col-center" gap={20} className="ctn-questions">
          <Header title="Questions pratiques" />
          <Flex type="center" className="list" wrap>
            {data.map((item, index) => (
              <Flex
                type="col"
                className={active === index ? "item active" : "item"}
                key={index}
              >
                <Flex
                  type="between-center"
                  className="header"
                  gap={10}
                  onClick={() =>
                    active === index ? setActive(null) : setActive(index)
                  }
                >
                  <Text>{item.title}</Text>
                  <TbChevronRight className="icon" />
                </Flex>
                <Flex className="bottom">
                  <Text size="xs">{item.content}</Text>
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Flex> */}
      </Flex>
    </SafeArea>
  );
}

export default Contact;
